export { default } from "./BasalCard";
